// Copyright Epic Games, Inc. All Rights Reserved.

import { Link, Tooltip } from "@material-ui/core";
import { Alert as AlertIcon } from "@epic-ui/icons";
import React from "react";
import { WithTheme } from "@material-ui/styles";
import styled, { CSSObject } from "styled-components";
import { Theme } from "@material-ui/core/styles";
import { useErrorCodeDescription } from "../../store/localization/hooks";

export interface IAlertProps {
  alertCode: string;
}

const StatusIcon = styled(AlertIcon)(
  ({ theme }: WithTheme<Theme>) =>
    ({
      color: theme.palette.warning.main,
      fontSize: "1rem",
      position: "absolute",
      right: 0,
      top: 0,
    } as CSSObject)
);

export const Alert = function ({ alertCode }: IAlertProps): JSX.Element {
  const link = `https://launcherhelp.epicgames.com/customer/portal/articles/search?q=${alertCode}`;
  const alertDescription = useErrorCodeDescription(alertCode);

  return (
    <Tooltip title={alertDescription} placement="top">
      <Link href={link} target="_blank">
        <StatusIcon />
      </Link>
    </Tooltip>
  );
};
